// Katalog sayfasının paket şeridi (spec §5 Katalog, DR15/DR17): görünür etiketli çoklu Paket süzgeci
// (`SearchMultiSelect`, `aria-multiselectable`) + "Seçili paketlerden en az birinde: 640 / 2.013
// (atalarıyla)" özeti. Durum `use-catalog-packages`'te. Katalogdan seçip "Pakete ekle ▾" 2026-11-03
// ürün kararıyla kaldırıldı — pakete gösterge eklemenin tek yolu Paketler ekranı.

import { useId } from "react";
import { KPI_PACKAGES_COPY } from "../../lib/kpi-packages-copy";
import { SearchMultiSelect } from "../common/SearchMultiSelect";
import type { SearchSelectOption } from "../common/SearchSelect";
import { labelStyle } from "./kpi-form-styles";

const C = KPI_PACKAGES_COPY.catalog;

export interface CatalogPackageBarProps {
  options: readonly SearchSelectOption[];
  filterIds: readonly string[];
  onFilterChange: (ids: string[]) => void;
  /** süzgeç açıkken görünür (atalarıyla) / toplam */
  counts: { visible: number; total: number } | null;
}

export function CatalogPackageBar(props: CatalogPackageBarProps): JSX.Element {
  const { options, filterIds, onFilterChange, counts } = props;
  const filterId = useId();
  return (
    <div className="mb-3" data-testid="kpi-catalog-pkg-bar">
      <div className="flex items-end gap-3 flex-wrap">
        <div style={{ flex: "0 1 360px", minWidth: 240, display: "grid", gap: 4 }}>
          <label htmlFor={filterId} style={labelStyle}>
            {C.filterLabel}
          </label>
          <SearchMultiSelect
            id={filterId}
            ariaLabel={C.filterLabel}
            values={filterIds}
            options={options}
            onChangeMany={onFilterChange}
            placeholder={C.filterPlaceholder}
            searchPlaceholder={C.filterSearch}
            removeLabel={C.chipRemove}
          />
        </div>
        {counts ? (
          <span
            role="status"
            className="text-sm"
            style={{ color: "var(--color-text-2)", paddingBottom: 12 }}
          >
            {C.filterSummary(counts.visible, counts.total)}
          </span>
        ) : null}
      </div>
    </div>
  );
}
